<template>
  <div>
    <v-textarea
      :dir="dir"
      :rules="rules"
      :label="label"
      v-model="innerValue"
      variant="outlined"
      hide-details="auto"
      :hint="hint"
      :type="keyboardType"
      :readonly="readOnly"
    >
      <template v-slot:append-inner v-if="isSearchable && !readOnly">
        <v-btn variant="text" icon size="small" @click="$emit('search', null)">
          <v-icon size="small">fa fa-search</v-icon>
        </v-btn>
      </template>
    </v-textarea>
  </div>
</template>

<script>
export default {
  name: "TextAreaInput",

  props: {
    modelValue: {
      type: String,
      default: null
    },
    label: String,
    hint: String,
    isRequired: Boolean,
    isSearchable: Boolean,
    dir: String,
    keyboardType: String,
    readOnly: Boolean
  },

  data() {
    return {
      innerValue: this.modelValue
    }
  },

  computed: {
    rules() {
      return this.isRequired ? [(value) => !!value || "الزامی"] : []
    }
  },

  watch: {
    modelValue(val) {
      this.innerValue = val
    },
    innerValue(val) {
      this.$emit("update:modelValue", val)
    }
  }
}
</script>
